import { Service } from '@roc/feature-app-core';
import { BalanceSheetReportTabs } from '../utils/constants';

const url = {
  GET_REPORT: '/api/v1/loan/trades/getBalanceSheetReport',
  DOWNLOAD_REPORT_BY_TYPE: '/api/v1/loan/trades/downloadBalanceSheetReportByType',
  DOWNLOAD_REPORT: '/api/v1/loan/trades/downloadBalanceSheetReport',
};

export class BalanceSheetReportService extends Service {

  getReport(
    type: BalanceSheetReportTabs,
    page: number,
    pageSize: number,
    sortDir: string,
    sortBy: string,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      url.GET_REPORT,
      {
        type,
        page,
        pageSize,
        sortDir,
        sortBy,
        filters,
        dropdownFilters
      },
      {
        disableGlobalLoading: true,
      }
    );
  }

  downloadReportByType(
    type: BalanceSheetReportTabs,
    filters: object,
    dropdownFilters: object
  ) {
    return this.get(
      `${url.DOWNLOAD_REPORT_BY_TYPE}`,
      {
        type,
        filters,
        dropdownFilters
      },
      {
        responseType: 'arraybuffer',
      }
    );
  }

  downloadReport(
  ) {
    return this.get(
      `${url.DOWNLOAD_REPORT}`,
      {
      },
      {
        responseType: 'arraybuffer',
      }
    );
  }
}
